import { Reveal, Eyebrow, CountUp } from "@/components/primitives";

export default function Pricing() {
  return (
    <section
      id="advantage"
      data-testid="pricing-section"
      className="bg-ink py-24 sm:py-36"
    >
      <div className="mx-auto max-w-7xl px-6 text-center sm:px-10">
        <Reveal className="flex justify-center">
          <Eyebrow index="03">The V-Elite Advantage</Eyebrow>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="mt-6 flex items-start justify-center">
            <span
              data-testid="pricing-number"
              className="gold-text font-display text-[38vw] font-black leading-[0.85] tracking-tighter sm:text-[13rem]"
            >
              <CountUp to={50} />
            </span>
            <span className="gold-text mt-[6vw] font-display text-[9vw] font-extrabold sm:mt-10 sm:text-6xl">
              %
            </span>
          </div>
        </Reveal>
        <Reveal delay={0.22}>
          <div className="mx-auto mt-4 h-px w-16 bg-gold/50" />
          <h2
            data-testid="pricing-headline"
            className="mt-6 font-display text-base font-bold uppercase tracking-[0.4em] text-ivory sm:text-lg"
          >
            Less Than Dealership Service
          </h2>
          <p
            data-testid="pricing-subtext"
            className="mx-auto mt-5 max-w-xs text-sm font-light leading-relaxed text-ivory/60 sm:max-w-sm sm:text-base"
          >
            Premium care without the premium price.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
